import { OMDB_axios_adapter,OMDB_BASE_URL } from "./OMDB_axios_adapter";

/**
 * https://www.omdbapi.com/
 */

const OMDB_api_service = {
    detailByTitleOrIDWithYearAndType: async (title, id, year, type) => {
        try {
            /**
             * t : title (optional)
             * i : IMDB ID (optional)
             * type : movie, series, episode
             */
            const params = {};
            if (title) {
                params.t = title;
            }
            else if (id) {
                params.i = id;
            }

            if (year) {
                params.y = year;
            }

            if (type) {
                params.type = type;
            }
            const response = await OMDB_axios_adapter.get(`${OMDB_BASE_URL}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    },
    searchByTitleWithYearAndType: async (title, year, type, page) => {
        try {
            /**
             * s : title (Required)
             * type : movie, series, episode
             * page : 1-100
             */
            const params = {};
            if (title) {
                params.s = title;
            }
            if (year) {
                params.y = year;
            }

            if (type) {
                params.type = type;
            }

            if (page && page > 1) {
                params.page = page;
            }
            else {
                params.page = 1;
            }
            const response = await OMDB_axios_adapter.get(`${OMDB_BASE_URL}`, { params });
            return response.data;
        } catch (error) {
            return error;
        }
    }
}

export default OMDB_api_service;